<a id="mbfs-header-login-cta" id="auto_triggerccpa" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)" hidden></a> 

<!--US Page-->
<div class="dtfccpa" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>

  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_CCPA_Header.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle" style="text-align:center;padding: 150px;">
        {{ 'CCPA.CCPATitle' | translate }}
      </h2>
     
    </section>
  </section>

  <section class='mbfs-repay-banner-inner' style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <!-- <h4 style="text-align:left ;padding-top: 81px; padding-left: 81px;">
          {{ 'CCPA.TermsPrivacyHeader' | translate }}
        </h4> -->
        <p class="mbfs-repay-banner-inner__header-text2" style="text-align:left ; padding-left: 81px;padding-right: 81px;">{{ 'CCPA.CCPACopy1' | translate }}</p>

        <div class ="onlinebackground">
          <section class="mercedes-me-login">
            <div class="mercedes-me-login__column">
              <ul class="mercedes-me-login__column-app-promotion-ul">
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy2' | translate }}</li>  
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy3' | translate }}</li>  
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy4' | translate }}</li>  
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy5' | translate }}</li>  
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy6' | translate }}</li>  
                <li class="mercedes-me-login__column-app-promotion-info"> {{ 'CCPA.CCPACopy7' | translate }}</li>  
              </ul>       
            </div>
          </section>
        </div>
        <p class="mbfs-repay-banner-inner__header-text2" style="text-align:left ; padding-bottom: 15px; padding-left: 81px;padding-right: 81px;">{{ 'CCPA.CCPACopy8' | translate }}</p>
  </section>
      <div class ="ccpaform">
    
      <form [formGroup]="ccpaForm" (ngSubmit)="submitCCPA($event)"  *ngIf="openLoginModal && !successCCPA">
        <p>{{ 'CCPA.CCPACopy9' | translate }}</p>

        <p>
          <label class="inputlabel">How would you like to receive your response? <b>*</b></label>
    
            <input required type="radio" name="notificationType"   (change)="onRadioChange($event)"  value="Mail" id="addressOn" class="accountInquiry-radio" />
            <strong>Mail &nbsp;&nbsp;</strong>
    
            <input required type="radio" name="notificationType"  (change)="onRadioChange($event)" value="Email" id="emailOn" class="accountInquiry-radio" />
            <strong>Email</strong>			
          </p>

        <label class="inputlabel">Select all that apply (at least one selection is mandatory): <b>*</b></label>
        <p>
        <input  type="checkbox" name="customerCheckbox1" value="currentCustomer" (change)="this.customerCheckbox1 = !this.customerCheckbox1">
        <strong>Current Customer&nbsp;&nbsp;</strong>
        
        <input  type="checkbox" name="customerCheckbox2" value="formerCustomer" id="formerCustomer" (change)="this.customerCheckbox2 = !this.customerCheckbox2">
        <strong>Former Customer &nbsp;&nbsp;</strong>
        
        <input type="checkbox" name="customerCheckbox3" value="applicant/Other" id="applicant/Other" (change)="this.customerCheckbox3 = !this.customerCheckbox3">
        <strong>Applicant/Other&nbsp;&nbsp;</strong>
        </p>
  
        <label class="inputlabel">Select all that apply (at least one selection is mandatory): <b>*</b></label>
        <p>
          <input  type="checkbox" name="customerRights1" value="rightToCategory" id="rightToCategory" (change)="this.customerRights1 = !this.customerRights1">
          <strong>Right to Know Request &nbsp;&nbsp;</strong>
                      
          <input type="checkbox" name="customerRights2" value="rightToDeletion" id="rightToDeletion" (change)="this.customerRights2 = !this.customerRights2">
          <strong>Right to Request Deletion &nbsp;&nbsp;</strong>
         </p>
  
         <label class="inputlabel">Requester Type: (at least one selection is mandatory): <b>*</b></label>
         <p>
          <input  type="checkbox" name="buyer" value="Buyer" id="Buyer" (change)="this.buyer = !this.buyer">
          <strong>Buyer &nbsp;&nbsp;</strong>
                      
          <input type="checkbox" name="guarantor" value="Guarantor" id="Guarantor" (change)="this.guarantor = !this.guarantor">
          <strong>Guarantor &nbsp;&nbsp;</strong>
          </p>

        <label class="inputlabel">Enter Account number(s) if known:</label>
        <textarea tabindex="1"class="form-control" rows="3" style="resize:none;" formControlName="accounts"  [value]="accounts" (input)="onValueChange($event)" [(ngModel)]="accounts"></textarea>

        <div class="shortrow">
          <div class="form-group">
            <label class ="inputlabel" for="first_name">First Name <b>*</b></label>
            <input type="text" class="form-control" formControlName="first_name" validateonblur required
            id="first_name" name="first_name">
          </div>
      
          <div class="form-group">
            <label class ="inputlabel" for="last_name">Last Name<b>*</b></label>
            <input type="text" class="form-control"  formControlName="last_name" required validateonblur
             id="last_name" name="last_name">
          </div>
      </div>
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="ssn">Enter Last 4 of SSN<b>*</b></label>
          <input type="number" class="form-control"  formControlName="ssn" required id="ssn" oninput="javascript: if (this.value.length > 4) this.value = this.value.slice(0, 4);" (input)="ssnValidator($event)"validateonblur name="ssn">
        </div>
        <div class="form-group">
          <label class ="inputlabel" for="phone">Phone Number<b>*</b> </label>
        <input class="form-control" id="phone" name="phone" type="number"  oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" (input)="inputValidator($event)" validateonblur formControlName="phone">
        </div>
      </div>
      <div class="shortrow">
        <div *ngIf="showPhoneErrors">
          <div *ngIf="!this.phoneValid">  
            <li style="color: black;font-weight: bold;"  *ngIf="!this.phoneLength">{{ 'LoginModal.PhoneLength' | translate }}</li>
          </div>
        </div>  
        <div *ngIf="showSsnErrors">
          <div *ngIf="!this.ssnValid">  
            <li style="color: black;font-weight: bold;"  *ngIf="!this.ssnLength">{{ 'LoginModal.SSNLength' | translate }}</li>
          </div>
        </div>  
      </div>
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="address">Address <b>*</b></label>
          <input type="text" class="form-control" formControlName="address"  validateonblur required id="address" maxlength="255" name="address">
        </div>
        <div class="form-group">
          <label class ="inputlabel" for="apt">Apt, Suite, etc.</label>
        <input class="form-control" type="text" formControlName="apt" id="apt" validateonblur name="apt" >
        </div>
      </div>
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="city">City <b>*</b></label>
          <input type="text" class="form-control"  required  id="city" maxlength="255" validateonblur formControlName="city" name="city">
        </div>
        <div class="form-group">
          <label class ="inputlabel" for="state">State <b>*</b></label>
        <input class="form-control" type="text" formControlName="state" required id="state" validateonblur name="state" >
        </div>
        <div class="form-group">
          <label class ="inputlabel" for="zipcode">Zip code <b>*</b></label>
          <input type="text" class="form-control"  required id="zipcode" validateonblur formControlName="zipcode" name="zipcode">
        </div>
      </div>
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="email">Email Address <b>*</b></label>
          <input type="text" class="form-control" formControlName="email"  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$" required  id="email" validateonblur  maxlength="255" name="email">
        </div>
        <div class="form-group">
          <label class ="inputlabel" for="reemail">Re-Enter Email Address <b>*</b></label>
        <input class="form-control" type="text" formControlName="reemail" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  required  id="reemail" validateonblur name="reemail" >
        </div>
      </div>
      <!-- <div class="shortrow">
          <li style="color: black;font-weight: bold;"  *ngIf="!this.reenteremailcheck">{{ 'LoginModal.ReEnterEmailCheck' | translate }}</li>
      </div>
   -->
      <div class="form-check">
        <label class="checkboxlabel" for="checkbox">
          <input type="checkbox" style="color: black;font-weight: bold;" class="form-check-input" id="checkbox" name="checkbox" required  (change)="this.disclaimer = !this.disclaimer">*   By submitting this form, I declare under penalty of perjury that I am the consumer whose personal information is the subject of the request
        </label>
      </div>

      <p>* indicates required field</p>

      <h5 style="color: #00566A !important;"  *ngIf="this.serviceErrorOccurred">{{this.serviceErrorDesc}}<br></h5>

      <div class="captcha" *ngIf="this.captchaToggle">
        <div id="capcha_element" class="g-recaptcha" data-theme="light"
            style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
            data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
          </div>
      </div>

      <button type="submit" name="submit" class="mbfs-button">Submit</button>
      <button class="mbfs-button">Clear All</button>
      </form>
     
      <form  (ngSubmit)="openLogin($event)" *ngIf="openLoginModal && successCCPA">
        <p>{{ 'CCPA.CCPACopy10' | translate }}</p>
        <p>{{ 'CCPA.CCPACopy11' | translate }}</p>
        <button type="submit" class="mbfs-button">LOG IN</button>
      </form>
  </div>
  </div>
 
 